
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 600 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h600v150H0z"}}),_c('path',{attrs:{"fill":"#007a3d","d":"M0 150h600v150H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M0 100h600v100H0z"}}),_c('path',{attrs:{"d":"M0 0l200 150L0 300z","fill":"#c4111b"}}),_c('circle',{attrs:{"cx":"300","cy":"150","r":"40","fill":"#c4111b"}}),_c('circle',{attrs:{"cx":"315","cy":"150","r":"40","fill":"#fff"}}),_c('path',{attrs:{"d":"M289.263 174.22l17.056-12.192 16.923 12.377-6.325-19.99 17-12.27-20.965-.16-6.416-19.961-6.632 19.89-20.966-.067 16.867 12.454-6.542 19.92z","fill":"#c4111b"}})])
          )
        }
      }
    